const CODE_CHALLENGE_STATUS = {
  invited: "invited",
  passed: "passed",
  failed: "failed",
  completed: "completed",
};

export default CODE_CHALLENGE_STATUS;
